import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { CloseRounded, SignalWifi0BarRounded, SignalWifi1BarRounded, SignalWifi2BarRounded, SignalWifi3BarRounded, SignalWifi4BarRounded, SignalWifiOffRounded, } from '@mui/icons-material';
export const IconElement = memo(forwardRef((props, ref) => {
    const { icon_type, ...rest } = props;
    switch (icon_type) {
        case 'wifi-not-configured':
            return (_jsxs(_Fragment, { children: [_jsx(CloseRounded, { color: "error", sx: {
                            position: 'absolute',
                            fontSize: '0.4em',
                            bottom: '5%',
                            left: -3,
                        } }), _jsx(ResponsiveIcon, { Icon: SignalWifiOffRounded, color: "disabled", ...rest, ref: ref })] }));
        case 'wifi-no':
            return (_jsx(ResponsiveIcon, { Icon: SignalWifiOffRounded, color: "disabled", ...rest, ref: ref }));
        case 'wifi-0':
            return (_jsx(ResponsiveIcon, { Icon: SignalWifi0BarRounded, ...rest, ref: ref }));
        case 'wifi-1':
            return (_jsx(ResponsiveIcon, { Icon: SignalWifi1BarRounded, ...rest, ref: ref }));
        case 'wifi-2':
            return (_jsx(ResponsiveIcon, { Icon: SignalWifi2BarRounded, ...rest, ref: ref }));
        case 'wifi-3':
            return (_jsx(ResponsiveIcon, { Icon: SignalWifi3BarRounded, ...rest, ref: ref }));
        default:
            return (_jsx(ResponsiveIcon, { Icon: SignalWifi4BarRounded, ...rest, ref: ref }));
    }
}));
IconElement.displayName = 'WiFiIconElement';
